import 'bootstrap';
import TopMenu from './components/TopMenu';
import MainMenu from './components/MainMenu';
import ContrastSwitch from './components/ContrastSwitch';
import CardButton from './components/CardButton';
import ScrollToTop from './components/ScrollToTop';
import Search from './components/Search';
import FormAccordionValidator from './components/FormAccordionValidator';

MainMenu.mount();
TopMenu.mount();
ContrastSwitch.mount();
CardButton.mount();
ScrollToTop.mount();
Search.mount();
FormAccordionValidator.mount();
